export enum ERole {
  supervisor = "supervisor",
  trainer = "trainer",
  curator = "curator"
}
